<div class="welcome-container">
  <div class="welcome-content">
    <!-- Logo Section -->
    <div class="logo-section">
      <img src="assets/logo-transparent.svg" alt="Hebern Logo" class="logo" />
    </div>

    <!-- Main Welcome Message -->
    <div class="welcome-message">
      <h1 class="welcome-title">Welcome to Hebern!</h1>
      <p class="welcome-subtitle">Thank you for joining our community</p>
    </div>

    <!-- Thank You Card -->
    <div class="thank-you-card">
      <div class="card-content">
        <div class="success-icon">
          <svg
            width="64"
            height="64"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="10" stroke="#efbf04" stroke-width="2" />
            <path
              d="m9 12 2 2 4-4"
              stroke="#efbf04"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <h2>You're All Set!</h2>
        <p class="confirmation-text">
          Thank you for signing up to receive updates from Hebern. You've
          successfully joined our email list and will be the first to know
          about:
        </p>
        <ul class="benefits-list">
          <li>Latest product updates and features</li>
          <li>Exclusive early access opportunities</li>
          <li>Security insights and best practices</li>
          <li>Community news and announcements</li>
        </ul>
      </div>
    </div>

    <!-- Next Steps Section -->
    <div class="next-steps">
      <h3>What's Next?</h3>
      <div class="steps-grid">
        <div class="step-item">
          <div class="step-number">1</div>
          <div class="step-content">
            <h4>Check Your Email</h4>
            <p>
              We've sent you a confirmation email. Please check your inbox and
              spam folder.
            </p>
          </div>
        </div>
        <div class="step-item">
          <div class="step-number">2</div>
          <div class="step-content">
            <h4>Stay Connected</h4>
            <p>
              Follow us on social media for real-time updates and community
              discussions.
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer Message -->
    <div class="footer-message">
      <p>Questions? We're here to help. Reach out to us anytime.</p>
      <p class="email-link">
        <a href="mailto:support@hebern.com">support@hebern.com</a>
      </p>
    </div>
  </div>
</div>
